import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import FormSection from "../../shared/component/form/FormSection";
import DataTable from "../../shared/component/dataTable/DataTable";
import LicenseReportColumn from "../../shared/component/dataTable/columns/LicenseReportColumn.json";
import Dialog from "../../shared/component/dialog/Dialog";
import AppLicenseSave from "./AppLicenseSave";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import LicenseService from "../../shared/service/LicenseService";
import MerchantBranchFilter from "./MerchantBranchFilter";
import {InputText} from "primereact/inputtext";
import '../../shared/styles/SettingsPage.css';


const defaultLicense = {
    id: null,
    licenseStatus: '',
    merchantBranchId: '',
    notes: '',
    eft: false,
    creditAddress: null,
    creditAddressUsed: null,
    creditDistance: null,
    creditDistanceUsed: null,
    appLicencesEntityList: []
};

export default class Licenses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            licenseList: [],
            merchantBranchList: [],
            license: Object.assign({}, defaultLicense),
            licenseTemp: Object.assign({}, defaultLicense),
        }
    }

    componentDidMount() {
        this.licenseService = new LicenseService();
        this.refreshDataTable();
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Licenses</h1>
                        </div>
                        <div className="settings-page__panel">
                            {this.renderFilter()}
                            {this.merchantLicenseList()}
                        </div>
                    </div>
                </AvForm>
            </div>
        );
    }

    closeDisplayDialogFilter = () => {
        this.setState({displayDialogFilter: false});
    }

    onDataSelectFilter = (data) => {
        this.setState({merchantBranchId: data.id});
        this.setState({merchantBranchName: data.tradingName});
        this.setState({displayDialogFilter: false});
    }

    renderFilter() {
        return (
            <div className="settings-page__filter settings-page__filter--lookup">
                <span className="p-input-icon-right p-input-icon-right--dual settings-page__lookup-wrap">
                    <InputText
                        className="settings-page__lookup-input"
                        disabled
                        value={this.state.merchantBranchName}
                        placeholder="Select Merchant Branch"
                        onClick={() => this.setState({displayDialogFilter: true})}/>
                <i
                    className="pi pi-search"
                    style={{cursor: "pointer"}}
                    onClick={() => this.setState({displayDialogFilter: true})}
                />

                <i
                    className="pi pi-times"
                    style={{cursor: "pointer"}}
                    onClick={() => {
                        this.setState({merchantBranchId: null, merchantBranchName: ''})

                    }}
                />

                <i
                    className="pi pi-refresh"
                    style={{cursor: "pointer"}}
                    onClick={() => {
                        this.refDataTable.dt.filter(this.state.merchantBranchId, "merchantBranchId", "equals");
                        let filterElement = this.refDataTable.state.filterElement;
                        filterElement["merchantBranchId"] = this.state.merchantBranchId;
                        this.refDataTable.setState({filterElement: filterElement});
                        this.refDataTable.onModelFilterChangeWithNameAndValue("merchantBranchId", this.state.merchantBranchId, "long");

                    }}
                />

                </span>

                <Dialog visible={this.state.displayDialogFilter}
                        header={"Merchant Branch"}
                        onHide={() => this.setState({displayDialogFilter: false})}
                        style={GeneralUtils.getDialogStyleForMerchantBranchFilter()}>
                    <MerchantBranchFilter
                        ref={(elem) => this.refModelCredentialsSave = elem}
                        onDataSelect={this.onDataSelectFilter}
                        closeDisplayDialog={this.closeDisplayDialogFilter}/>
                </Dialog>
            </div>
        );
    }

    merchantLicenseList() {
        return (
            <div>
                <FormSection>
                    <div className="settings-page__table-wrap">
                    <DataTable ref={(elem) => this.refDataTable = elem} fields={LicenseReportColumn.fields}
                               objectName={LicenseReportColumn.name}
                               dataURL="crm/merchant/license/all"
                               rows={10}
                               selectionMode="single" onDataSelect={this.onDataSelect}
                               loading={this.state.loading}/>
                    </div>

                    <Dialog visible={this.state.displayDialog}
                            header={"License"}
                            onHide={() => this.setState({displayDialog: false})}
                            style={{width: '60vw', height: '35vw'}}>

                        <AppLicenseSave
                            refreshDataTable={this.refreshDataTable} ref={(elem) => this.refModelSave = elem}
                            closeDisplayDialog={this.closeDisplayDialog}
                            appLicense={this.state.selectedAppLicense}
                            getMerchantBranchId={this.getMerchantBranchId}
                            saveAppLicense={(row) => {
                                this.licenseService.updateApplicence(row)
                                    .then((response) => {
                                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                            this.setState({
                                                licenseSaveButtonRender: false

                                            });
                                            this.refreshDataTable();
                                        }
                                    });


                            }}
                            deleteAppLicense={(id) => {
                                this.licenseService.deleteApplicence(id)
                                    .then((response) => {
                                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                            this.setState({
                                                licenseSaveButtonRender: false

                                            });
                                            this.refreshDataTable();
                                        }
                                    });


                            }}
                        />
                    </Dialog>

                </FormSection>
            </div>)
    }

    getMerchantBranchId = () => {
        return this.state.license.merchantBranchId;
    }
    saveLicense = () => {
        let license = this.state.license;
        license["merchantBranchId"] = this.props.getMerchantBranchId();
        this.setState({license: license});

        if (!GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            this.licenseService.update(this.state.license)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {

                        this.setState({
                            license: response,
                            licenseTemp: Object.assign({}, response),
                            licenseSaveButtonRender: false
                        })
                        this.props.refreshDataTable();

                    }
                });
        } else {
            this.licenseService.create(this.state.license)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {

                        this.setState({
                            license: response,
                            licenseTemp: Object.assign({}, response),
                            licenseSaveButtonRender: false
                        })
                        this.props.refreshDataTable();

                    }
                });
        }

    }
    refreshDataTable = () => {
        this.closeDisplayDialog();
        this.refDataTable.refresh();
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }

    onDataSelect = (data) => {
        GeneralUtils.openDialogThenRef(this, {
            displayDialog: true,
            license: data
        }, () => this.refModelSave, (ref) => ref.setData(Object.assign({}, data)));
    }


    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let mailSettings = this.state.mailSettings;
        mailSettings[e.target.name] = value;
        this.setState({mailSettings: mailSettings});
    }

}

